// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_hl-0";
export var discountCodeInput = "_hl-1";